import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/productos/categorias`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(categoria) {
    return new Promise((resolve, reject) => {
      var data = new FormData()

      // Carga del FormData
      Object.keys(categoria).map(function(key) {
        data.append(key, categoria[key])
      })

      var imagen = document.getElementsByName("foto")

      if (imagen.length > 0) data.append('foto', imagen[0].files[0])

      if (categoria._eliminarFotoAntigua)
        data.append('eliminar_foto_antigua', true)

      var req = new XMLHttpRequest()
      req.open('POST', API + '/productos/categorias/' + categoria.id, true)
      req.setRequestHeader(
        'Authorization',
        localStorage.getItem('argusblack.token')
      )

      req.onreadystatechange = function() {
        if (req.readyState == 4) {
          switch (req.status) {
            case 200:
              resolve({ data: req.responseText })
              break
            default:
              reject({
                response: {
                  status: req.status,
                  data: req.responseText
                }
              })
              break
          }
        }
      }

      req.send(data)
    })
  },

  categoriaJSON(idCategoria) {
    return apiClient.get(`${idCategoria}.json`)
  },

  categoriasJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/productos/categorias.json`, { params: params })
  },

  eliminar(idCategoria) {
    return apiClient.delete(`${idCategoria}`)
  },

  guardar(categoria) {
    return new Promise((resolve, reject) => {
      var data = new FormData()

      // Carga del FormData
      Object.keys(categoria).map(function(key) {
        data.append(key, categoria[key])
      })

      var imagen = document.getElementsByName("foto")

      if (imagen.length > 0) data.append('foto', imagen[0].files[0])

      var req = new XMLHttpRequest()
      req.open('POST', API + '/productos/categorias', true)
      req.setRequestHeader(
        'Authorization',
        localStorage.getItem('argusblack.token')
      )

      req.onreadystatechange = function() {
        if (req.readyState == 4) {
          switch (req.status) {
            case 200:
              var id = req.responseText
              resolve({ data: id })
              break
            default:
              reject({
                response: {
                  data: req.responseText
                }
              })
              break
          }
        }
      }

      req.send(data)
    })
  }
}
